import React from 'react';
import { ContentfulRichText } from 'common/components';
import { useClassName } from 'common/hooks';
import OptionsInput from './OptionsInput';
import './form-step.less';
import DateInput from './DateInput';
import Input from './Input';
import PhoneInput from './PhoneInput';
import CheckboxInput from './CheckboxInput';

export default function FormStep({
  component,
  handleInputChange,
  formValues,
  lockedFields = [],
}) {
  const classNames = useClassName('CLPFormStep');

  return (
    <div className={classNames('container')}>
      <div className={classNames('title-container')}>
        <p className={classNames('title')}>{component.fields.title}</p>
        {component.fields.description && (
          <section className={classNames('description')}>
            <ContentfulRichText
              field={{ 'en-US': component.fields.description }}
            />
          </section>
        )}
      </div>
      <div className={classNames('inputs-container')}>
        {component.fields?.fields?.map((input, index) => {
          const func = {
            radio: () => OptionsInput,
            checkbox: () =>
              input.fields.options?.length ? OptionsInput : CheckboxInput,
            date: () => DateInput,
            text: () => Input,
            email: () => Input,
            number: () => Input,
            phone: () => PhoneInput,
            'text-area': () => Input,
          }[input.fields.type];
          if (!func) return null;
          const Component = func();
          if (!Component) return null;
          return (
            <Component
              input={input}
              key={index}
              handleInputChange={handleInputChange}
              value={formValues[input.fields.name]?.value}
              locked={lockedFields.includes(input.fields.name)}
            />
          );
        })}
      </div>
    </div>
  );
}
